import {
    type WorkflowReference,
    hasVersion,
    type AppFlowWorkflow,
} from '../../../shared/domain/workflows/types.no-deps'
import { IDB_workflowRead, IDB_workflowsWrite } from '../IDB/IDB.table.workflow'
import { Serv_clientWithLogger } from '../Serv/Serv.client'
import { IDB_oldWorkflows } from '../IDB/IDB.dexie'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { Imag_preCacheFlowImages } from '../Imag/Imag.getUrls'
import { Cust_hasFeature } from '../Cust/Cust.hasFeature'

/**
 * Make sure we have the version of the workflow we need on disk
 */
export async function WF_ensureVersionOnDisk(logger: ClientLogger, reference: WorkflowReference) {
    try {
        if (!hasVersion(reference)) return null
        const localWorkflow = await IDB_workflowRead(reference.id)

        // If we already have this version, no worries, move on
        if (localWorkflow?.numberOfVersions === reference.version) return null

        const richText = Cust_hasFeature('workflow.richText-element')
        // Fetch it from the server
        const { workflow: serverWorkflow } = await Serv_clientWithLogger(logger).getWorkflow(reference.id, {
            workflowVersion: reference.version,
            includeDeleted: true,
            richText,
        })

        const workflowToSave: AppFlowWorkflow = {
            ...serverWorkflow,
            name: serverWorkflow.name.text,
            numberOfVersions: reference.version,
            procedure: null,
        }

        if (localWorkflow == null) {
            await IDB_workflowsWrite(logger, [workflowToSave])
        } else {
            await IDB_oldWorkflows().put(workflowToSave)
        }

        await Imag_preCacheFlowImages([workflowToSave])

        logger.log(`saved workflow version to idb`, { workflowId: reference.id, workflowVersion: reference.version })

        return workflowToSave
    } catch (error) {
        logger.error(error, { workflowReference: reference })
    }
}
